import { render, staticRenderFns } from "./DispensedItemStatusButton.vue?vue&type=template&id=46ab4f55&"
import script from "./DispensedItemStatusButton.vue?vue&type=script&lang=ts&"
export * from "./DispensedItemStatusButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports